/*******************************************************************************
 * Copyright (c) 2022 THERAYTEK
 *
 * All rights reserved.
 *
 * Contributors:
 *   James Worthington - Initial implementation
 *   
 *   Amina Rais - Massive Improvements
 *
 * Version: 1
 *
 *******************************************************************************/

export const LOGIN = 'LOGIN'
export const REGISTER = 'REGISTER'
export const SET_USER = 'SET_USER'
export const LOGOUT = "LOGOUT"
export const SET_USER_BY_ID = "SET_USER_BY_ID"